export default "__VITE_ASSET__CeeoGD5n__"